module.exports = __webpack_public_path__ + "img/viator-logo.723b7c6.png";